import { render, staticRenderFns } from "./TotalDistanceChart.vue?vue&type=template&id=6d8165e5"
import script from "./TotalDistanceChart.vue?vue&type=script&lang=js"
export * from "./TotalDistanceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports